import Guid from '@/app/utils/guid';

export default class Permission {

  public id: string = Guid.empty()
  public name: string = ''
  public description: string = ''
}
